import { Box, Stack, Typography } from '@mui/joy';
import { addMonths, isSameMonth, subMonths } from 'date-fns';
import { ko } from 'date-fns/locale';
import React, { FC } from 'react';
import DatePicker from 'react-datepicker';
import { FaRegCalendarMinus } from 'react-icons/fa6';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

const DatePickerInput = React.forwardRef<HTMLDivElement | null>(({ value, onClick, className }: any, ref) => (
  <Stack
    className={className}
    onClick={onClick}
    ref={ref}
    direction={'row'}
    alignItems={'center'}
    spacing={'12px'}
    sx={{ cursor: 'pointer' }}>
    <FaRegCalendarMinus />
    <Typography level="title-md">{value}</Typography>
  </Stack>
));

const YearMonthNavigator: FC<{ value: Date; onChange: (value: Date) => void }> = ({ value, onChange }) => {
  const [minDate] = React.useState<Date>(new Date('2023-01-01'));
  const [maxDate] = React.useState<Date>(addMonths(new Date(), 1));

  const disabledNextBtn = isSameMonth(maxDate, value);
  const disabledPrevBtn = isSameMonth(minDate, value);

  const handlePrev = () => {
    if (!disabledPrevBtn) {
      onChange(subMonths(value, 1));
    }
  };
  const handleNext = () => {
    if (!disabledNextBtn) {
      onChange(addMonths(value, 1));
    }
  };

  const renderMonthContent = (m: number, shortMonthText: string, fullMonthText: string, day: Date) => {
    return `${m + 1}월`;
  };

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={11} justifyContent="center">
      <Box
        sx={{ cursor: !disabledPrevBtn ? 'pointer' : undefined, width: 10, opacity: disabledPrevBtn ? 0.2 : undefined }}
        onClick={handlePrev}>
        <MdChevronLeft fontSize={30} />
      </Box>
      <Box>
        <DatePicker
          selected={value}
          customInput={<DatePickerInput />}
          renderMonthContent={renderMonthContent}
          dateFormat="yyyy년 MM월"
          dateFormatCalendar="yyyy년 MM월"
          showMonthYearPicker
          minDate={minDate}
          maxDate={maxDate}
          onChange={(date) => {
            if (date) {
              onChange(date);
            }
          }}
          locale={ko}
        />
      </Box>
      <Box
        sx={{ cursor: !disabledNextBtn ? 'pointer' : undefined, width: 10, opacity: disabledNextBtn ? 0.2 : undefined }}
        onClick={handleNext}>
        <MdChevronRight fontSize={30} />
      </Box>
    </Stack>
  );
};

export default YearMonthNavigator;
